/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as BikesIndexRouteImport } from "./routes/bikes/index"
import { Route as BikesBikeIdRouteRouteImport } from "./routes/bikes/$bikeId/route"
import { Route as ImagesIndexRouteImport } from "./routes/images/index"
import { Route as RegionsIndexRouteImport } from "./routes/regions/index"
import { Route as ReviewsIndexRouteImport } from "./routes/reviews/index"
import { Route as RoutesIndexRouteImport } from "./routes/routes/index"
import { Route as ToursIndexRouteImport } from "./routes/tours/index"
import { Route as ToursTourIdRouteRouteImport } from "./routes/tours/$tourId/route"
import { Route as BikesBikeIdIndexRouteImport } from "./routes/bikes/$bikeId/index"
import { Route as BikesBikeIdImagesRouteImport } from "./routes/bikes/$bikeId/images"
import { Route as RoutesRouteIdIndexRouteImport } from "./routes/routes/$routeId/index"
import { Route as ToursTourIdIndexRouteImport } from "./routes/tours/$tourId/index"
import { Route as ToursTourIdImagesRouteImport } from "./routes/tours/$tourId/images"
import { Route as ToursTourIdRouteBuilderRouteImport } from "./routes/tours/$tourId/route-builder"
import { Route as ToursTourIdTourDatesRouteImport } from "./routes/tours/$tourId/tour-dates"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const BikesIndexRoute = BikesIndexRouteImport.update({
  id: "/bikes/",
  path: "/bikes/",
  getParentRoute: () => rootRouteImport,
} as any)
const BikesBikeIdRouteRoute = BikesBikeIdRouteRouteImport.update({
  id: "/bikes/$bikeId",
  path: "/bikes/$bikeId",
  getParentRoute: () => rootRouteImport,
} as any)
const ImagesIndexRoute = ImagesIndexRouteImport.update({
  id: "/images/",
  path: "/images/",
  getParentRoute: () => rootRouteImport,
} as any)
const RegionsIndexRoute = RegionsIndexRouteImport.update({
  id: "/regions/",
  path: "/regions/",
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewsIndexRoute = ReviewsIndexRouteImport.update({
  id: "/reviews/",
  path: "/reviews/",
  getParentRoute: () => rootRouteImport,
} as any)
const RoutesIndexRoute = RoutesIndexRouteImport.update({
  id: "/routes/",
  path: "/routes/",
  getParentRoute: () => rootRouteImport,
} as any)
const ToursIndexRoute = ToursIndexRouteImport.update({
  id: "/tours/",
  path: "/tours/",
  getParentRoute: () => rootRouteImport,
} as any)
const ToursTourIdRouteRoute = ToursTourIdRouteRouteImport.update({
  id: "/tours/$tourId",
  path: "/tours/$tourId",
  getParentRoute: () => rootRouteImport,
} as any)
const BikesBikeIdIndexRoute = BikesBikeIdIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => BikesBikeIdRouteRoute,
} as any)
const BikesBikeIdImagesRoute = BikesBikeIdImagesRouteImport.update({
  id: "/images",
  path: "/images",
  getParentRoute: () => BikesBikeIdRouteRoute,
} as any)
const RoutesRouteIdIndexRoute = RoutesRouteIdIndexRouteImport.update({
  id: "/routes/$routeId/",
  path: "/routes/$routeId/",
  getParentRoute: () => rootRouteImport,
} as any)
const ToursTourIdIndexRoute = ToursTourIdIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ToursTourIdRouteRoute,
} as any)
const ToursTourIdImagesRoute = ToursTourIdImagesRouteImport.update({
  id: "/images",
  path: "/images",
  getParentRoute: () => ToursTourIdRouteRoute,
} as any)
const ToursTourIdRouteBuilderRoute = ToursTourIdRouteBuilderRouteImport.update({
  id: "/route-builder",
  path: "/route-builder",
  getParentRoute: () => ToursTourIdRouteRoute,
} as any)
const ToursTourIdTourDatesRoute = ToursTourIdTourDatesRouteImport.update({
  id: "/tour-dates",
  path: "/tour-dates",
  getParentRoute: () => ToursTourIdRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/bikes/$bikeId": typeof BikesBikeIdRouteRouteWithChildren
  "/tours/$tourId": typeof ToursTourIdRouteRouteWithChildren
  "/bikes/": typeof BikesIndexRoute
  "/images/": typeof ImagesIndexRoute
  "/regions/": typeof RegionsIndexRoute
  "/reviews/": typeof ReviewsIndexRoute
  "/routes/": typeof RoutesIndexRoute
  "/tours/": typeof ToursIndexRoute
  "/bikes/$bikeId/images": typeof BikesBikeIdImagesRoute
  "/tours/$tourId/images": typeof ToursTourIdImagesRoute
  "/tours/$tourId/route-builder": typeof ToursTourIdRouteBuilderRoute
  "/tours/$tourId/tour-dates": typeof ToursTourIdTourDatesRoute
  "/bikes/$bikeId/": typeof BikesBikeIdIndexRoute
  "/routes/$routeId/": typeof RoutesRouteIdIndexRoute
  "/tours/$tourId/": typeof ToursTourIdIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/bikes": typeof BikesIndexRoute
  "/images": typeof ImagesIndexRoute
  "/regions": typeof RegionsIndexRoute
  "/reviews": typeof ReviewsIndexRoute
  "/routes": typeof RoutesIndexRoute
  "/tours": typeof ToursIndexRoute
  "/bikes/$bikeId/images": typeof BikesBikeIdImagesRoute
  "/tours/$tourId/images": typeof ToursTourIdImagesRoute
  "/tours/$tourId/route-builder": typeof ToursTourIdRouteBuilderRoute
  "/tours/$tourId/tour-dates": typeof ToursTourIdTourDatesRoute
  "/bikes/$bikeId": typeof BikesBikeIdIndexRoute
  "/routes/$routeId": typeof RoutesRouteIdIndexRoute
  "/tours/$tourId": typeof ToursTourIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/bikes/$bikeId": typeof BikesBikeIdRouteRouteWithChildren
  "/tours/$tourId": typeof ToursTourIdRouteRouteWithChildren
  "/bikes/": typeof BikesIndexRoute
  "/images/": typeof ImagesIndexRoute
  "/regions/": typeof RegionsIndexRoute
  "/reviews/": typeof ReviewsIndexRoute
  "/routes/": typeof RoutesIndexRoute
  "/tours/": typeof ToursIndexRoute
  "/bikes/$bikeId/images": typeof BikesBikeIdImagesRoute
  "/tours/$tourId/images": typeof ToursTourIdImagesRoute
  "/tours/$tourId/route-builder": typeof ToursTourIdRouteBuilderRoute
  "/tours/$tourId/tour-dates": typeof ToursTourIdTourDatesRoute
  "/bikes/$bikeId/": typeof BikesBikeIdIndexRoute
  "/routes/$routeId/": typeof RoutesRouteIdIndexRoute
  "/tours/$tourId/": typeof ToursTourIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/bikes/$bikeId"
    | "/tours/$tourId"
    | "/bikes/"
    | "/images/"
    | "/regions/"
    | "/reviews/"
    | "/routes/"
    | "/tours/"
    | "/bikes/$bikeId/images"
    | "/tours/$tourId/images"
    | "/tours/$tourId/route-builder"
    | "/tours/$tourId/tour-dates"
    | "/bikes/$bikeId/"
    | "/routes/$routeId/"
    | "/tours/$tourId/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/bikes"
    | "/images"
    | "/regions"
    | "/reviews"
    | "/routes"
    | "/tours"
    | "/bikes/$bikeId/images"
    | "/tours/$tourId/images"
    | "/tours/$tourId/route-builder"
    | "/tours/$tourId/tour-dates"
    | "/bikes/$bikeId"
    | "/routes/$routeId"
    | "/tours/$tourId"
  id:
    | "__root__"
    | "/"
    | "/bikes/$bikeId"
    | "/tours/$tourId"
    | "/bikes/"
    | "/images/"
    | "/regions/"
    | "/reviews/"
    | "/routes/"
    | "/tours/"
    | "/bikes/$bikeId/images"
    | "/tours/$tourId/images"
    | "/tours/$tourId/route-builder"
    | "/tours/$tourId/tour-dates"
    | "/bikes/$bikeId/"
    | "/routes/$routeId/"
    | "/tours/$tourId/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BikesBikeIdRouteRoute: typeof BikesBikeIdRouteRouteWithChildren
  ToursTourIdRouteRoute: typeof ToursTourIdRouteRouteWithChildren
  BikesIndexRoute: typeof BikesIndexRoute
  ImagesIndexRoute: typeof ImagesIndexRoute
  RegionsIndexRoute: typeof RegionsIndexRoute
  ReviewsIndexRoute: typeof ReviewsIndexRoute
  RoutesIndexRoute: typeof RoutesIndexRoute
  ToursIndexRoute: typeof ToursIndexRoute
  RoutesRouteIdIndexRoute: typeof RoutesRouteIdIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/bikes/": {
      id: "/bikes/"
      path: "/bikes"
      fullPath: "/bikes/"
      preLoaderRoute: typeof BikesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/bikes/$bikeId": {
      id: "/bikes/$bikeId"
      path: "/bikes/$bikeId"
      fullPath: "/bikes/$bikeId"
      preLoaderRoute: typeof BikesBikeIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/images/": {
      id: "/images/"
      path: "/images"
      fullPath: "/images/"
      preLoaderRoute: typeof ImagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/regions/": {
      id: "/regions/"
      path: "/regions"
      fullPath: "/regions/"
      preLoaderRoute: typeof RegionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/reviews/": {
      id: "/reviews/"
      path: "/reviews"
      fullPath: "/reviews/"
      preLoaderRoute: typeof ReviewsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/routes/": {
      id: "/routes/"
      path: "/routes"
      fullPath: "/routes/"
      preLoaderRoute: typeof RoutesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/tours/": {
      id: "/tours/"
      path: "/tours"
      fullPath: "/tours/"
      preLoaderRoute: typeof ToursIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/tours/$tourId": {
      id: "/tours/$tourId"
      path: "/tours/$tourId"
      fullPath: "/tours/$tourId"
      preLoaderRoute: typeof ToursTourIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/bikes/$bikeId/": {
      id: "/bikes/$bikeId/"
      path: "/"
      fullPath: "/bikes/$bikeId/"
      preLoaderRoute: typeof BikesBikeIdIndexRouteImport
      parentRoute: typeof BikesBikeIdRouteRoute
    }
    "/bikes/$bikeId/images": {
      id: "/bikes/$bikeId/images"
      path: "/images"
      fullPath: "/bikes/$bikeId/images"
      preLoaderRoute: typeof BikesBikeIdImagesRouteImport
      parentRoute: typeof BikesBikeIdRouteRoute
    }
    "/routes/$routeId/": {
      id: "/routes/$routeId/"
      path: "/routes/$routeId"
      fullPath: "/routes/$routeId/"
      preLoaderRoute: typeof RoutesRouteIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/tours/$tourId/": {
      id: "/tours/$tourId/"
      path: "/"
      fullPath: "/tours/$tourId/"
      preLoaderRoute: typeof ToursTourIdIndexRouteImport
      parentRoute: typeof ToursTourIdRouteRoute
    }
    "/tours/$tourId/images": {
      id: "/tours/$tourId/images"
      path: "/images"
      fullPath: "/tours/$tourId/images"
      preLoaderRoute: typeof ToursTourIdImagesRouteImport
      parentRoute: typeof ToursTourIdRouteRoute
    }
    "/tours/$tourId/route-builder": {
      id: "/tours/$tourId/route-builder"
      path: "/route-builder"
      fullPath: "/tours/$tourId/route-builder"
      preLoaderRoute: typeof ToursTourIdRouteBuilderRouteImport
      parentRoute: typeof ToursTourIdRouteRoute
    }
    "/tours/$tourId/tour-dates": {
      id: "/tours/$tourId/tour-dates"
      path: "/tour-dates"
      fullPath: "/tours/$tourId/tour-dates"
      preLoaderRoute: typeof ToursTourIdTourDatesRouteImport
      parentRoute: typeof ToursTourIdRouteRoute
    }
  }
}

interface BikesBikeIdRouteRouteChildren {
  BikesBikeIdImagesRoute: typeof BikesBikeIdImagesRoute
  BikesBikeIdIndexRoute: typeof BikesBikeIdIndexRoute
}

const BikesBikeIdRouteRouteChildren: BikesBikeIdRouteRouteChildren = {
  BikesBikeIdImagesRoute: BikesBikeIdImagesRoute,
  BikesBikeIdIndexRoute: BikesBikeIdIndexRoute,
}

const BikesBikeIdRouteRouteWithChildren =
  BikesBikeIdRouteRoute._addFileChildren(BikesBikeIdRouteRouteChildren)

interface ToursTourIdRouteRouteChildren {
  ToursTourIdImagesRoute: typeof ToursTourIdImagesRoute
  ToursTourIdRouteBuilderRoute: typeof ToursTourIdRouteBuilderRoute
  ToursTourIdTourDatesRoute: typeof ToursTourIdTourDatesRoute
  ToursTourIdIndexRoute: typeof ToursTourIdIndexRoute
}

const ToursTourIdRouteRouteChildren: ToursTourIdRouteRouteChildren = {
  ToursTourIdImagesRoute: ToursTourIdImagesRoute,
  ToursTourIdRouteBuilderRoute: ToursTourIdRouteBuilderRoute,
  ToursTourIdTourDatesRoute: ToursTourIdTourDatesRoute,
  ToursTourIdIndexRoute: ToursTourIdIndexRoute,
}

const ToursTourIdRouteRouteWithChildren =
  ToursTourIdRouteRoute._addFileChildren(ToursTourIdRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BikesBikeIdRouteRoute: BikesBikeIdRouteRouteWithChildren,
  ToursTourIdRouteRoute: ToursTourIdRouteRouteWithChildren,
  BikesIndexRoute: BikesIndexRoute,
  ImagesIndexRoute: ImagesIndexRoute,
  RegionsIndexRoute: RegionsIndexRoute,
  ReviewsIndexRoute: ReviewsIndexRoute,
  RoutesIndexRoute: RoutesIndexRoute,
  ToursIndexRoute: ToursIndexRoute,
  RoutesRouteIdIndexRoute: RoutesRouteIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
